// main imports
import * as React from "react";

// plugin imports
import { Link, Trans } from "@herob191/gatsby-plugin-react-i18next";

// style imports
import "./layout.scss";
import "../../styles/main.scss";
import "swiper/css";

// svg imports
import Icon from "../../svg/icon.svg";

// components imports
import CookiesBanner from "./cookiesBanner/cookiesBanner";
import SmoothScroll from "./smoothScroll";
import Footer from "./footer/footer";
import { LayoutContext } from "../../context/layoutContext";
import Marquee from "../marquee/marquee";
import useTranslate from "../../utils/useTranslate";
import useRestaurantDetails from "../../utils/restaurantDetails";

// util imports
import { AnimatePresence, motion } from "motion/react";
import { slideFade } from "../../utils/motionAnimations";
import Separator from "../spacers/separatorH";

// component
export default function Layout({ children }) {
	const { restaurantId } = React.useContext(LayoutContext);
	const restaurant = useRestaurantDetails(restaurantId);
	const restaurantTitle = useTranslate(restaurant?.frontmatter?.title);
	return (
		<SmoothScroll>
			<div className={`${restaurant ? restaurant.fields.id : ""}`}>
				<nav className="padding">
					<div className="navBarTop borderThick blurBg">
						<div className="navCTA invertOnHover">
							<Link
								to="/reserva/"
								className="padding red"
								activeClassName="underline"
								partiallyActive
							>
								<span className="h2">
									<Trans>Reservar</Trans>
								</span>
							</Link>
							<Separator vertical thick red />
						</div>

						<Link to="/">
							<Icon className="navLogo" />
						</Link>
					</div>
				</nav>

				<main>
					<AnimatePresence mode="wait">
						<motion.div
							className="restaurantTopMarquee"
							key={restaurantId}
							initial="hidden"
							animate="show"
							exit="exit"
							{...slideFade}
						>
							<Marquee>
								{restaurantTitle && (
									<span className="h1">Kaisushi {restaurantTitle}</span>
								)}
							</Marquee>
						</motion.div>
					</AnimatePresence>

					{children}
					<CookiesBanner />
				</main>

				<Footer />
			</div>
		</SmoothScroll>
	);
}
